module.exports = __WEBPACK_EXTERNAL_MODULE_43__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 43
// module chunks = 0